import Flex from '@eversports/react-components/primitives/Flex'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import Text from '@eversports/react-components/primitives/Text'
import PyroForm from 'pyro-form'
import React from 'react'

import { Localized } from '../../../localization/react'
import { MultiAnswerPatronQuestionInitialValues, PatronageAnswer } from '../../../typings/AdditionalInformation'
import { PatronageAnswerMapping } from './patronage-answer-utils'

interface Props {
  initialValues: MultiAnswerPatronQuestionInitialValues
  venueName: string
  patronageAnswers: Array<PatronageAnswerMapping>
  handleChange: (values: MultiAnswerPatronQuestionInitialValues) => void
}

const MultiAnswerPatronQuestionComponent: React.FC<React.PropsWithChildren<Props>> = ({
  initialValues,
  venueName,
  patronageAnswers,
  handleChange,
}) => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Text color="subtleText" fontWeight="bold" textTransform="uppercase">
      <Localized id="additional-info-multi-answer-patron-question-title" params={{ venueName }} />
    </Text>
    <Text>
      <Localized id="additional-info-multi-answer-patron-question-subtitle" params={{ venueName }} />
    </Text>
    <PyroForm initialValues={initialValues} onChange={handleChange}>
      <Flex flexDirection="column">
        {patronageAnswers.map((patronageAnswer) => (
          <RadioButton
            name="patronageAnswer"
            key={patronageAnswer.value}
            value={patronageAnswer.value}
            label={<Localized id={patronageAnswer.label as any} params={{ venueName }} />}
            data-testid={`multi-answer-patron-question-${
              patronageAnswer.value === PatronageAnswer.PATRONAGE_ANSWER_EVERSPORTS ? 'eversports' : 'other'
            }`}
          />
        ))}
      </Flex>
    </PyroForm>
  </Flex>
)

export default MultiAnswerPatronQuestionComponent
